import styled from 'styled-components';
import { ThemeButton } from '../../ThemedButton';
import { colors } from 'constants/colors';

export const ReadyButton = styled(ThemeButton)`
  width: 100%;

  &:disabled {
    background-color: ${colors.buttonLightGreen};
    color: ${colors.white};
  }
`;

export const ButtonTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  line-height: 18px;
`;
